import { isEqual } from 'lodash'

export type VendorItem = {
  id: number,
  name: string
}

export type Vendor = {
  address1: string,
  address2: string,
  city: string,
  country: string,
  countrySubDivisionCode: string,
  email: string,
  faxPhone: string,
  id: number,
  isActive: boolean,
  mobilePhone: string,
  name: string,
  postalCode: string,
  primaryPhone: string,
  qboDisplayName: string,
  qboId: string
}

export type QboVendor = {
  billAddr?: QboVendorBillingAddress,
  displayName: string,
  fax: string,
  id: string,
  mobile?: string,
  primaryEmailAddr?: {
    address: string
  },
  primaryPhone?: {
    freeFormNumber: string
  }
}

export type QboVendorBillingAddress = {
  city: string
  country: string
  countrySubDivisionCode: string
  line1: string
  postalCode: string
}

export const emptyVendor = (): Vendor => ({
  address1: '',
  address2: '',
  city: '',
  country: '',
  countrySubDivisionCode: '',
  email: '',
  faxPhone: '',
  id: 0,
  isActive: true,
  mobilePhone: '',
  name: '',
  postalCode: '',
  primaryPhone: '',
  qboDisplayName: '',
  qboId: ''
})

export const filterVendors = (vendors: VendorItem[], filter: string): VendorItem[] => {
  return vendors.filter(vendor => vendor.name.toLowerCase().includes(filter.toLowerCase()))
}

export const updateFromQboVendor = (vendor: Vendor, qboVendor: QboVendor, updateInfo: boolean): Vendor => {
  const updatedVendor = {
    ...vendor,
    qboDisplayName: qboVendor.displayName,
    qboId: qboVendor.id,
  }

  if(updateInfo) {
    updatedVendor.name = qboVendor.displayName
    updatedVendor.primaryPhone = qboVendor.primaryPhone?.freeFormNumber ?? ''
    updatedVendor.mobilePhone = qboVendor.mobile ?? ''
    updatedVendor.email = qboVendor.primaryEmailAddr?.address ?? ''

    if(qboVendor.billAddr) {
      updatedVendor.address1 = qboVendor.billAddr.line1
      updatedVendor.city = qboVendor.billAddr.city
      updatedVendor.country = qboVendor.billAddr.country
      updatedVendor.countrySubDivisionCode = qboVendor.billAddr.countrySubDivisionCode
      updatedVendor.postalCode = qboVendor.billAddr.postalCode
    }
  }

  return updatedVendor
}

export const hasVendorChanged = (serverVendor: Vendor | undefined, stateVendor: Vendor, selectedVendorId: number | undefined) => {
  if (selectedVendorId === 0) {
    return true
  }

  if (serverVendor === undefined) {
    return false
  }

  return !isEqual(serverVendor, stateVendor)
}